import { render, staticRenderFns } from "./buy_success2.vue?vue&type=template&id=d47e7964&scoped=true&"
import script from "./buy_success2.vue?vue&type=script&lang=js&"
export * from "./buy_success2.vue?vue&type=script&lang=js&"
import style0 from "./buy_success2.vue?vue&type=style&index=0&id=d47e7964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47e7964",
  null
  
)

export default component.exports